// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__1MJxB","row":"Sidebar_row__1k8qe","col":"Sidebar_col__29_iV","randomize":"Sidebar_randomize__1iR-F"};